import {Button, styled} from "@mui/material";

// Add button
export const AuthButton = styled(Button)(({theme}) => ({
    backgroundColor: theme.barekam.login.actionButton.backgroundColor,
    color: theme.barekam.login.actionButton.color,

    display: 'flex',
    height: '3rem',
    padding: '0.75rem 1.5rem',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.75rem',
    alignSelf: 'stretch',
    borderRadius: '0.5rem',
    width: '100%',

    '&:hover': {
        background: theme.barekam.login.actionButton.backgroundHoverColor,
    }
}));

export const AuthTypeSelectButton = styled(Button)(() => ({
    backgroundColor: '#F1F1FB',

    display: 'flex',
    padding: '1.5rem 0rem',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '1rem',
    alignSelf: 'stretch',
    color: 'unset',
    minWidth: '12rem',

    '&:hover': {
        backgroundColor: '#F1F1FB',
    }
}));
